@if (!!entity()) {
  <div
    [ngbTooltip]="disabledTooltip() | translate"
    [disableTooltip]="!disabled()"
    class="natural-language-tooltip-container"
    [attr.data-automation]="dataAutomation()"
  >
    <div
      class="natural-language-expression"
      [ngClass]="{ 'natural-language-expression--disabled': disabled() }"
      data-automation="natural-language-editor-content"
    >
      <ng-content></ng-content>
      <span>.</span>
    </div>
    @if (feedback || externalFeedback) {
      <div
        class="natural-language-expression__feedback text-danger small"
        data-automation="natural-language-editor-feedback"
      >
        {{ feedback || externalFeedback | translate }}
      </div>
    }
  </div>
}
